import React, { useEffect, useState } from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Sidebar from "../components/Sidebar";

import {
  TbBuildingCommunity,
  TbChartHistogram,
  TbCurrencyEuro,
  TbDatabase,
  TbHome,
  TbMail,
  TbUsersGroup,
} from "react-icons/tb";
import { knowAcces } from "../utils/utils";

export const AppLayout = () => {
  const isAmministrazioneOnly = knowAcces(["amministrazione"]) && !knowAcces([
    "admin", "team_leader", "paghe", "assunzioni", "segreteria", "f24", "consulente",
  ]);
  const [collapsed, setCollapsed] = useState(false);

  const [screenSize, getDimension] = useState(window.innerWidth);

  const [links, setLinks] = useState([
    {
      id: 1,
      href: "/Home",
      icon: <TbHome className="li-icon" />,
      text: "Home",
      visibility: !isAmministrazioneOnly,
    },
    {
      id: 2,
      href: "/Clienti",
      icon: <TbBuildingCommunity className="li-icon" />,
      text: "Clienti",
      visibility: true,
    },
    {
      id: 3,
      href: "/F24",
      icon: <span className="text-[11px] font-black tracking-tight">F24</span>,
      text: "F24",
      visibility: knowAcces([
        "paghe",
        "team_leader",
        "admin",
        "segreteria",
        "f24",
      ]),
    },
    {
      id: 5,
      href: "/Parcellazione",
      icon: <TbCurrencyEuro className="li-icon" />,
      text: "Parcellazione",
      visibility: knowAcces(["parc_admin", "parc_team_leader", "parc_paghe", "parc_assunzioni", "parc_consulente", "parc_amministrazione"]),
    },
    {
      id: 6,
      href: "/Newsletter",
      icon: <TbMail className="li-icon" />,
      text: "Newsletter",
      // Visibile a TUTTI gli utenti loggati: admin/team_leader hanno accesso
      // completo (crea/modifica/invia/statistiche), gli altri vedono solo le
      // newsletter già inviate in sola lettura (filtro lato backend getAll +
      // gating bottoni lato frontend tramite canManage).
      visibility: !isAmministrazioneOnly,
    },
    {
      id: 7,
      href: "/Referenti",
      icon: <TbUsersGroup className="li-icon" />,
      text: "Referenti",
      visibility: knowAcces(["admin", "team_leader"]),
    },
    {
      id: 8,
      href: "/Statistiche",
      icon: <TbChartHistogram className="li-icon" />,
      text: "Statistiche",
      visibility: knowAcces(["admin", "team_leader"]),
    },
    {
      id: 9,
      href: "/Anagrafiche",
      icon: <TbDatabase className="li-icon" />,
      text: "Anagrafiche",
      visibility: knowAcces(["admin", "team_leader"]),
    },
    /* {
			id: 9 ,
			href: '/',
			//icon: <HiOutlineArrowRightOnRectangle className="li-icon" />,
			icon: <HiOutlinePower className='li-icon' />,
			text: 'Logout',
			async func() {
        try {
          await axiosPrivate.get('logout');
        } catch (error) {
          console.error(error);
        }
      },
		}, */
  ]);

  const setDimension = () => {
    getDimension(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
      if (screenSize <= "1024") {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
  }, [screenSize]);

  useEffect(() => {
    if (collapsed) {
      sessionStorage.setItem("sidebar", "80px");
    } else {
      sessionStorage.setItem("sidebar", "250px");
    }
  }, [collapsed]);

  return (
    <>
      <ToastContainer />
      <Sidebar links={links} setLinks={setLinks} />
    </>
  );
};
